import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import { Box, Divider, Typography } from '@mui/material'
import AccordionRoot from '../accordion/AccordionRoot'
import AccordionItem from '../accordion/AccordionItem'
import AccordionTrigger from '../accordion/AccordionTrigger'
import AccordionContent from '../accordion/AccordionContent'
import useServiceClassifications from './useServiceClassifications'
import { Navigate } from 'react-router-dom'
import ListSkeleton from '../skeletons/ListSkeleton'

type ServicesListProps = {
  vendorId: string
}

const ServicesList: React.FC<ServicesListProps> = ({ vendorId }) => {
  const {
    serviceListProps: { serviceClassifications, onChange, selectedServiceClassifications },
    isLoading,
    isError
  } = useServiceClassifications(vendorId ?? '')

  if (isError) {
    return <Navigate to="/error" replace />
  }

  if (isLoading) {
    return <ListSkeleton items={5} />
  }

  return (
    <>
      <AccordionRoot>
        {serviceClassifications.map((header) => {
          const selectedCount = header.services.filter((service) =>
            selectedServiceClassifications.includes(service.id)
          ).length

          return (
            <AccordionItem key={header.group} value={header.group}>
              <AccordionTrigger>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', flex: 1, alignItems: 'center' }}>
                  <Typography>{header.group}</Typography>
                  {selectedCount !== 0 && (
                    <Typography
                      color="textSecondary"
                      variant="body2"
                    >{`Valittu ${selectedCount} / ${header.services.length}`}</Typography>
                  )}
                </Box>
              </AccordionTrigger>
              <AccordionContent>
                {header.services.map((service, index) => {
                  const isSelected = selectedServiceClassifications.includes(service.id)
                  return (
                    <React.Fragment key={service.id}>
                      <Box
                        sx={{
                          px: 2,
                          py: 1,
                          cursor: 'pointer',
                          ':hover': { bgcolor: 'grey.50' }
                        }}
                        onClick={() => {
                          onChange(service.id, !isSelected)
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', ml: -1.5 }}>
                          <Checkbox id={service.id} checked={isSelected} disableRipple />
                          <Typography>{service.name}</Typography>
                        </Box>
                      </Box>
                      {index !== header.services.length - 1 && <Divider />}
                    </React.Fragment>
                  )
                })}
              </AccordionContent>
            </AccordionItem>
          )
        })}
      </AccordionRoot>
    </>
  )
}

export default ServicesList
